export default __webpack_public_path__ + "static/media/sutures-packaging.01a1d3ad.png";